import { useEffect, useState } from 'react'

const OrganizationLogo = ({ slug, styles = null, onCheck = null }) => {
  const [organizationLogo, setOrganizationLogo] = useState(null)

  const localLogoPath = `${CONFIG.assetsBaseURL}/images/organization-license-logos`

  // Uploaded logos live under a stable, extensionless key — the content type
  // travels with the object, which is what lets the same URL serve a PNG or an
  // SVG. cdnURL is unset in dev, where the same path is served locally from
  // disk by the dev-only handler in server/app.js.
  const orgLogosPath = `${CONFIG.cdnURL || ''}/usercontent/orglogos`

  const logosInPublicFolder = [
    'astra-zeneca-2208-1',
    'purdue-university',
    'university-of-zurich',
    'zambon',
    'the-hang-seng-university-of'
  ]

  const checkImageExists = () => {
    if (!slug) return setOrganizationLogo(null)

    const imageUrl = `${orgLogosPath}/${slug}`

    if (organizationLogo === imageUrl) return // Skip if already loaded

    const image = new Image()
    image.src = imageUrl

    image.onerror = () => {
      // validation for logos that aren't stored in S3, but exists in public folder
      if (slug && logosInPublicFolder.includes(slug)) {
        const srcInPublicFoler = `${localLogoPath}/${slug}.png`
        return setOrganizationLogo(srcInPublicFoler)
      }

      setOrganizationLogo(null)

      if (onCheck) {
        onCheck(null)
      }
    }

    image.onload = () => {
      setOrganizationLogo(imageUrl)
      if (onCheck) {
        onCheck(imageUrl)
      }
    }
  }

  useEffect(() => {
    checkImageExists()
  }, [slug])

  return (
    <>{organizationLogo && <img src={organizationLogo} alt={`Organization logo of ${slug}`} className={styles} />}</>
  )
}

export default OrganizationLogo
